import { render, staticRenderFns } from "./LibAppFooter.vue?vue&type=template&id=2056fc2f&scoped=true"
import script from "./LibAppFooter.vue?vue&type=script&lang=js"
export * from "./LibAppFooter.vue?vue&type=script&lang=js"
import style0 from "./LibAppFooter.vue?vue&type=style&index=0&id=2056fc2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2056fc2f",
  null
  
)

export default component.exports